import { useLocation } from 'react-router-dom';
import { getOptionsByRoute } from './constants';
import { useState } from 'react';
import useGetData from '../useGetData';
import { IOptions } from './types';

const useOptionsChatFloating = () => {
  const location = useLocation();

  const [value, setValue] = useState<string>('default');

  const { data } = useGetData(value);

  const handleChangeSetValue = (v: string) => {
    setValue(v);
  };

  const getBasePath = (path: string): string => {
    const parts = path.split('/');
    const baseParts = parts.slice(0, 2);
    return baseParts.join('/');
  };

  const options = getOptionsByRoute(getBasePath(location.pathname));

  const { prompt } =
    options.find((item) => item.value === value) ?? ({} as IOptions);

  return { options, prompt, data, handleChangeSetValue };
};

export default useOptionsChatFloating;
